import { render, staticRenderFns } from "./risk-attendance-table.view.vue?vue&type=template&id=2185fd22&scoped=true&"
import script from "./risk-attendance-table.view.vue?vue&type=script&lang=ts&"
export * from "./risk-attendance-table.view.vue?vue&type=script&lang=ts&"
import style0 from "./risk-attendance-table.view.vue?vue&type=style&index=0&id=2185fd22&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2185fd22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VRow,VTooltip})
